var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8002 16.0002C28.8002 23.0694 23.0694 28.8002 16.0002 28.8002C8.93095 28.8002 3.2002 23.0694 3.2002 16.0002C3.2002 8.93095 8.93095 3.2002 16.0002 3.2002C23.0694 3.2002 28.8002 8.93095 28.8002 16.0002ZM16.9346 16.5013H19.2186L19.5209 13.5633H16.9348V11.8326C16.9348 11.1835 17.3638 11.0311 17.6688 11.0311H19.5287V8.17664L16.9654 8.16592C14.1205 8.16592 13.4741 10.2968 13.4741 11.6576V13.5606H11.8283V16.5013H13.4741V24.8688H16.9346V16.5013Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.66c5bb8a3790d003fa566a729ed1bc0e.svg";
export { ForwardRef as ReactComponent };